import { render, staticRenderFns } from "./channel-message.vue?vue&type=template&id=5dc8678d&scoped=true&"
import script from "./channel-message.vue?vue&type=script&lang=js&"
export * from "./channel-message.vue?vue&type=script&lang=js&"
import style0 from "./channel-message.vue?vue&type=style&index=0&id=5dc8678d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc8678d",
  null
  
)

export default component.exports